<template>
  <div class="nuttrema-instructions-list" :class="{ 'is-draggable': edit }">
    <nuttrema-empty-result
      v-if="_isEmpty(instructions)"
      class="is-transparent"
      predefined-set="landscape">
    </nuttrema-empty-result>
    <ul v-else>
      <draggable v-model="instructions" @end="onEnd" :options="options.draggable">
        <li v-for="instruction in instructions" :key="instruction.id">
          <div class="instruction__step">
            <span>{{ $t('label.step') }} {{ instruction.seq + 1 }}</span>
            <a class="instruction_move">
              <i class="far fa-arrows-alt-v"></i>
            </a>
          </div>
          <div class="instruction__holder">
            <div class="instruction__line">
              <div class="instruction__line--space-before">
                <div class="instruction__line--hr"></div>
              </div>
              <span class="instruction__line--required-time-min" v-if="instruction.time_required_min">{{ $t('label.required_time_min', { time: instruction.time_required_min }) }}</span>
              <div class="instruction__line--space-after">
                <div class="instruction__line--hr"></div>
              </div>
            </div>
            <div class="instruction__description">
              <div class="instruction__icon">
                <nuttrema-iconica-sidebar-link :text="String(instruction.seq + 1)" theme="instruction-step"></nuttrema-iconica-sidebar-link>
              </div>
              <div class="instruction__text">
                <p class="instruction__text--title">
                  {{ instruction.title }}
                </p>
                <p class="instruction__text--description">{{ instruction.instruction }}</p>
              </div>
              <div class="instruction__link" v-if="edit">
                <router-link tag="a" activeClass="is-active" class="el-button el-button--text el-button--list-item"
                  :to="{ name: _get(meta, 'navigation.edit'), params: { entityInstructionID: instruction.id } }">
                  {{ $t('label.edit') }} <i class="el-icon-arrow-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </li>
      </draggable>
    </ul>
  </div>
</template>

<script>
/* eslint-disable object-shorthand */
import { each, cloneDeep } from 'lodash';
import draggable from 'vuedraggable';

import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'cmpt-instructions-list',
  props: {
    StuffToEatInstructions: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
    meta: {
      required: true,
    },
  },
  components: {
    draggable,
    NuttremaEmptyResult,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      opened: false,
      instructions: [],
      options: {
        draggable: {
          disabled: true,
        },
      },
    };
  },
  methods: {
    getSequence() {
      const sequence = [];
      each(this.instructions, (instruction, index) => {
        sequence.push({ id: instruction.id, seq: index });
        index += 1;
      });
      return sequence;
    },
    onEnd() {
      const sequence = this.getSequence();
      console.log('sorted', sequence);
      this.$emit('reorder', { sequence });
    },
  },
  watch: {
    StuffToEatInstructions: {
      handler: function () {
        this.instructions = cloneDeep(this.StuffToEatInstructions.data);
      },
      deep: true,
    },
    edit(newValue) {
      this.options.draggable.disabled = !newValue;
    },
  },
  created() {
    this.instructions = cloneDeep(this.StuffToEatInstructions.data);
    this.options.draggable.disabled = !this.edit;
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/mixins/mixins";

  $border-color: #DBE2EF;
  $bg-color: #FFF;
  $help-color: #555;
  $stripe-bg: #fafbfd;

  .nuttrema-instructions-list {

    flex-grow: 1;
    height: 100%;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    background-color: $bg-color;
    position: relative;

    @include background-stripe($stripe-bg, #fff, 7em, 7.001em);

    &:after {
      z-index: 0;
      width: 100%;
      content: '';
      height: 100%;
      opacity: 0.1;
      position: absolute;
      background: transparent url('~assets/images/dc-logo-bg.svg') no-repeat;
      background-position: right -8em bottom -8em;
      background-size: 48em;
    }

    ul {
      z-index: 1;
      display: flex;
      margin: 1.5em 0;
      flex-direction: column;
      overflow-y: auto;
      position: relative;
      li {
        display: flex;
        margin-bottom: 1.5em;
        align-self: stretch;

        .instruction__step {
          width: 7em;
          display: flex;
          flex-shrink: 0;
          align-self: stretch;
          align-items: flex-end;
          flex-direction: column;
          span {
            padding-right: 0.5em;
            font-size: 0.95rem;
            color: $help-color;
          }
          .instruction_move {
            flex-grow: 1;
            display: none;
            opacity: 0;
            align-self: center;
            align-items: center;
            transition: all 0.15s linear;
            > * {
              align-self: center;
              font-size: 1.5rem;
              color: rgba($help-color, 0.25);
            }
            &:hover {
              > * {
                color: rgba($help-color, 0.75);
              }
            }
          }
        }
        .instruction__line {
          flex-grow: 1;
          display: flex;
          margin-left: 0.5em;
          align-items: center;
          justify-content: space-between;

          .instruction__line--required-time-min {
            flex-shrink: 0;
            margin: 0 0.5em;
            font-size: 0.9rem;
            color: $help-color;
          }

          .instruction__line--space-before {
            width: 4em;
            flex-shrink: 0;
          }

          .instruction__line--space-after {
            flex-grow: 1;
          }

          .instruction__line--hr {
            width: 100%; height: 1.5em;
            display: block;
            position: relative;
            &:before {
              display: inline-block;
              width: 100%;
              height: 100%;
              top: -50%;
              left: 0;
              content: ' ';
              position: absolute;
              border-bottom: 1px solid $border-color;
            }
            &.dotted:before {
              border-bottom: 1px dotted $border-color;
            }
          }
        }
        .instruction__holder {
          flex-grow: 1;
          display: flex;
          align-self: stretch;
          flex-direction: column;
          .instruction__description {
            display: flex;
            justify-content: space-between;
            .instruction__icon {
              width: 5em;
              display: flex;
              flex-shrink: 0;
              align-self: flex-start;
              justify-content: center;
              align-items: flex-start;
            }

            .instruction__text {
              flex-grow: 1;
              flex-shrink: 1;
              align-self: flex-start;
              .instruction__text--title {
                font-weight: 500;
                margin-bottom: 0.25em;
              }
              .instruction__text--description {
                font-size: 0.95rem;
                color: $help-color;
              }

              &:last-child {
                padding: 0 1em 0 0;
              }
            }

            .instruction__link {
              flex-shrink: 0;
              align-self: center;
              padding: 0 1em;
            }

          }
          .instruction__related_content {

          }
        }
      }
    }

    &.is-draggable {
      ul li {
        .instruction_move {
          opacity: 1;
          display: flex;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/instructions/cmpt-instructions-list.vue